import React from "react"
import { useParams } from "react-router-dom"
import PasswordReset from "./password.reset"

const UidPasswordReset = () =>{
    const Uid = useParams()
    console.log("params check",Uid)
    return(
        <div>
            <PasswordReset Uid = {Uid} />
        </div>
    )
}

export default UidPasswordReset